import React, { FC } from 'react'
import { CheckboxProps } from './types'
import {
  CheckboxContainer,
  CheckboxLabel,
  CheckboxInput,
  Checkmark,
  CheckboxErrorText
} from './Checkbox.styles'

const Checkbox: FC<CheckboxProps> = props => {
  const { error } = props

  return (
    <CheckboxContainer {...props}>
      <CheckboxLabel
        htmlFor={props.id}
        version={props.version}
        removeMargins={props.removeMargins}
        {...props.labelProps}
      >
        {props.label}
        <CheckboxInput type='checkbox' {...props} />
        <Checkmark small={props.small} error={error} version={props.version} />
      </CheckboxLabel>
      {error && <CheckboxErrorText>{error}</CheckboxErrorText>}
    </CheckboxContainer>
  )
}

Checkbox.defaultProps = {
  disabled: false,
  small: false,
  readOnly: false,
  removeMargins: false,
  label: '',
  error: '',
  version: 1,
}

export default Checkbox
